<template>
  <v-card flat class="ma-2 px-0">
    <v-layout mt-2>
      <v-flex xs9>
        <v-card-text>
          <v-layout column fill-height mx-0>
            <v-layout column>
              <v-flex class="py-0">
                <div class="subtitle-1">{{ enquiry.product.name }}</div>
              </v-flex>
              <v-flex class="py-0">
                <div class="text--secondary">
                  <span style="font-weight: 600">Funding Type:</span>
                  {{ enquiry.product.type.name }}
                </div>
              </v-flex>
              <v-flex class="py-0">
                <div class="text--secondary">
                  <span style="font-weight: 600">Date Funded:</span>
                  {{ enquiry.date_funding_obtained | moment('DD/MM/YYYY') }}
                </div>
              </v-flex>
              <v-flex xs4 class="py-0">
                <div class="text--secondary">
                  <span style="font-weight: 600">Amount Funded:</span>
                  {{ enquiry.funding_obtained | currency }}
                </div>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-flex>
      <v-flex xs3>
        <v-card-text>
          <v-layout column align-end>
            <v-flex class="text-right">
              <v-chip color="green" text-color="white">FUNDING RELEASED</v-chip>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'ReferralEnquiry',
  props: ['enquiry']
};
</script>
